import axios from "axios";

export default {
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async getArticles(type, searchQuery) {
      if (!searchQuery || searchQuery.length < 3 || this.isLoading) {
        return [];
      }

      const currentType =
        type === "by_element_id" ? "article_element" : "article_original";

      this.isLoading = true;

      const articles = await axios
        .post("/local/ajax/route/catalog/find_articules/?page=request_page", {
          type,
          [currentType]: searchQuery
        })
        .then(res => res.data.articles || [])
        .catch(error => new Error(error));

      this.isLoading = false;

      return articles;
    },
    /**
     *
     * @param prop - Имя переменной в которой хранится текст из поля
     * @param key - Имя свойства в объекте form, которое хранит в себе значение из поля
     * @param items - Выбранные элементы в поле
     */
    onChangeArticle(prop, key, items) {
      this[prop] = null;
      this.copyOfForm[key] = items;
    },
    /**
     *
     * @param key - Имя переменной в которой хранится текст из поля для поиска артикулов
     * @param type - Тип который мы передаем при запросе на получение списка артикулов
     * @param value - Новое значение из поля для поиска артикулов
     * @returns {Promise<void>}
     */
    async onUpdateArticleSearchInput(key, type, value) {
      this[key] = await this.getArticles(type, value);
    }
  }
};
